import { _Link, ButtonLink } from "@/components/atoms";

interface UIProps {
  text: string;
  link: string;
  className?: string;
  darkText?: boolean;
  asLink?: boolean;
  visual?: boolean;
  target?: "_blank" | "_self";
}

const UI = ({
  text,
  link,
  darkText,
  asLink = false,
  target,
  visual,
  className,
}: UIProps) => {
  if (asLink)
    return (
      <_Link
        href={link}
        underlined
        color={darkText ? "dark" : "light"}
        target={target}
        size="large"
        visual={visual}
        className={className}
      >
        <span className="uppercase">{text}</span>
      </_Link>
    );
  return (
    <ButtonLink
      href={link}
      color="transparent"
      outlined
      textColor={darkText ? "black" : "white"}
      target={target}
      visual={visual}
      className={className}
    >
      <span className="uppercase">{"+"}</span>
      <span className="uppercase">{text}</span>
    </ButtonLink>
  );
};

export default UI;
